import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_BANKS_PERMISSION_URL } from "../constants"
import { RootState } from "../../store/store"
import { TPermissionBanksResponse, IErrorResponse } from "../interface"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export const fetchPermissionIds = async (token: string | null) => {
  const response = await axios(`${API_BANKS_PERMISSION_URL}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка получения информации о банке")
  }

  return response.data
}

export const usePermissionIds = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<TPermissionBanksResponse, IErrorResponse>({
    queryKey: ["permission-ids"],
    queryFn: () => fetchPermissionIds(token),
    enabled: Boolean(token),
  })
}
